module.exports = __webpack_public_path__ + "img/empireoperatingsystemsite-square.6c6c9b66.png";